import * as React from 'react';

import {
	FormInput,
	FormContext,
	FORM_CONSTANTS,
	getValueByName,
	setValueByName,
} from '../shared';


function withFormSelectField<S,T>(WrappedComponent: React.ComponentType<S>): React.ComponentClass<Partial<S> & FormInput<T>> {
	return class extends React.Component<Partial<S> & FormInput<T>> {
		static displayName = `withFormSelectField[HOC](${WrappedComponent.displayName || WrappedComponent.name})`;
		static defaultProps = {
			validationRules: [],
		} as any;
		static contextType = FormContext;
		validationRules = [];
		inputRef = React.createRef<{input: HTMLInputElement}>();

		componentWillMount() {
			const { name, required } = this.props;
			this.validationRules = [...this.props.validationRules] || [];

			if (required) {
				const { code, errorText } = FORM_CONSTANTS.REQUIRED;
				this.validationRules.unshift({
					code,
					errorText,
					fn: (formObject) => Boolean(getValueByName(name, formObject)),
				});
			}

			this.validationRules.forEach(v => this.context.addValidationRule(v));
		}

		componentWillUnmount() {
			this.validationRules.forEach(v => this.context.removeValidationRule(v));
		}

		isValid = () => this.validationRules.every(vr => vr !== this.context.getErrorValidationRule());

		handleChange = (e: React.SyntheticEvent<HTMLInputElement>, valueId: string | number, value: any, ...rest) => {
			const { getFormObject, setFormObject, sortValidationRulesByPriority, validateForm } = this.context;
			const { name, onChange, disableSetFullObject, enableOnChangeValidation } = this.props;
			const formObject = getFormObject();

			this.validationRules.forEach(v => sortValidationRulesByPriority(v));
			setValueByName(disableSetFullObject ? valueId : value, name, formObject);
			setFormObject(formObject);
			enableOnChangeValidation && validateForm(formObject);

			typeof onChange === 'function' && onChange(e, value, ...rest);
		};

		render() {
			const { name, validationRules, enableOnChangeValidation, disableSetFullObject, ...rest } = this.props;
			const { getFormObject, getErrorValidationRule } = this.context;
			const formObject = getFormObject();
			const validationRule = getErrorValidationRule();
			const errorText = validationRule ? validationRule.errorText : '';
			const value = getValueByName(name, formObject);
			const isValid = this.isValid();

			return (
				<WrappedComponent
					{...rest as any}
					error={!isValid}
					helperText={!isValid && Boolean(errorText) ? errorText : ''}
					value={value}
					onChange={this.handleChange}
				/>
			);
		}
	}
}

export default withFormSelectField;
